import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil, Trash2 } from "lucide-react";
import { Actions } from "../Actions/Actions";
import styles from "../styles.module.scss";
import { warehouseData, WarehouseRow } from "./utils";
import { WarehouseEnity } from "../../entitys";

interface WarehouseTableProps {
  onEdit: (shipment: WarehouseEnity) => void;
  onDelete: (shipment: WarehouseEnity) => void;
}

const WarehousesTable: React.FC<WarehouseTableProps> = ({
  onEdit,
  onDelete,
}) => {
  const warehouseColumns: ColumnsType<WarehouseRow> = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Location", dataIndex: "location", key: "location" },

    {
      title: "Storage limit",
      dataIndex: "storageLimit",
      key: "limit",
      align: "right",
    },
    {
      title: "Monthly storage fee",
      dataIndex: "monthlyFee",
      key: "monthly",
      align: "right",
      render: (v) => `£${v.toFixed(0)}`,
    },
    {
      title: "Long-term storage fee",
      dataIndex: "longTermFee",
      key: "longTerm",
      align: "right",
      render: (v) => `£${v.toFixed(0)}`,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 150,
      render: (_: unknown, row: WarehouseRow) => (
        <Actions
          record={row}
          actions={[
            {
              icon: <Pencil />,
              onClick: (r) =>
                onEdit({
                  address: r.location,
                  country: r.location,
                  name: r.name,
                  type: r.type,
                }),
            },
            {
              icon: <Trash2 />,
              onClick: (r) => onDelete(r as unknown as WarehouseEnity),
            },
          ]}
        />
      ),
    },
  ];
  return (
    <Table
      columns={warehouseColumns}
      dataSource={warehouseData}
      pagination={{ pageSize: 10 }}
      rowKey="key"
      scroll={{ x: 100 }}
      className={styles.table}
    />
  );
};

export default WarehousesTable;
